import { Controller } from "@hotwired/stimulus"

// A server-drawn table that follows Studio's column order (step 4, 2026-10-19):
// every th and td carries data-col="<key>"; the columns value (the company's
// order from Studio::TableColumnsChange) moves the cells into that order and
// hides the ones left out. Cells without a key keep their place. When Studio
// changes the columns, the chat sets the value and the table re-sorts itself.
export default class extends Controller {
  static values = { columns: { type: Array, default: [] } }

  connect() {
    this.apply()
    // The chat swaps in a fresh <thead> from the server after a change (drawn in the server's fixed order): sort again.
    this._onStudioColumns = () => this.apply()
    window.addEventListener("studio:table-columns", this._onStudioColumns)
  }

  disconnect() { window.removeEventListener("studio:table-columns", this._onStudioColumns) }
  columnsValueChanged() { this.apply() }

  apply() {
    const order = this.columnsValue
    if (!order.length) return
    this.element.querySelectorAll("tr").forEach((tr) => {
      const keyed = [...tr.children].filter((c) => c.dataset.col)
      if (!keyed.length) return
      const byKey = {}
      keyed.forEach((c) => { byKey[c.dataset.col] = c })
      const anchor = keyed[0]
      let last = anchor.previousElementSibling
      order.forEach((key) => {
        const cell = byKey[key]
        if (!cell) return
        cell.hidden = false
        if (last ? last.nextElementSibling !== cell : tr.firstElementChild !== cell) tr.insertBefore(cell, last ? last.nextElementSibling : tr.firstElementChild)
        last = cell
      })
      keyed.forEach((c) => { if (!order.includes(c.dataset.col)) c.hidden = true })
    })
  }
}
